import React, { PropsWithChildren } from 'react';
import { gql } from '@yi/core';

import { BaseCarousel, BaseCarouselComposerProps, createSlickSettings } from './BaseCarousel';
import { CarouselPlaceholder } from './CarouselPlaceholder';
import { WithPlaceholder } from './types';
import { TeacherCard } from '../cards';

type CarouselItem = gql.typesClient.Fragment_TeacherCard & {
  styles?: ({ name: string } | null)[] | null;
};
type Props = BaseCarouselComposerProps<CarouselItem>;

type PlaceholderProps = Pick<Props, 'button'>;
const Placeholder: React.FC<PlaceholderProps> = ({ button }) => (
  <CarouselPlaceholder
    cardDimension={TeacherCard.dimension}
    headerDimensions={{ headerHeight: 14, headerWidth: 226 }}
    noButton={button === null}
  />
);
export const TeacherCarousel: React.FC<PropsWithChildren<Props>> &
  WithPlaceholder<PlaceholderProps> = props => {
  const { dark = false } = props;
  const defaultProps = {
    renderCard: (cardProps: { item: CarouselItem }) => <TeacherCard light={dark} {...cardProps} />,
    getReactKey: (i: CarouselItem) => i.full_name,
    slickSettings: createSlickSettings({
      sm: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
      },
      md: {
        slidesToShow: 3,
        slidesToScroll: 2,
        dots: false,
      },
      lg: {
        slidesToShow: 4,
        slidesToScroll: 3,
        dots: false,
      },
      xl: {
        slidesToShow: 6,
        slidesToScroll: 5,
        dots: false,
      },
      xxl: {
        slidesToShow: 6,
        slidesToScroll: 5,
        dots: false,
      },
    }),
  };
  return <BaseCarousel<CarouselItem> {...defaultProps} {...props} />;
};
TeacherCarousel.Placeholder = Placeholder;
